<template>
  <div class="relative">
    <router-view></router-view>
    <call-in
      v-if="receivingCall !== null"
      :caller="receivingCall"
      @accept="acceptCallIn"
      @reject="rejectCallIn"
      @videoOnOff="videoOnOff"
      @stopStream="stopStream"
    ></call-in>
  </div>
</template>

<script>
import { VTextField } from 'vuetify/lib' // import a dummy component to compile vuetify sass variables
import CallIn from '@/components/Common/CallIn'

import videoCallMixin from '@/mixins/videoCall'

export default {
  components: {
    VTextField,
    CallIn,
  },
  mixins: [ videoCallMixin ],
  mounted () {
    this.newSocket()
  },
  methods: {
    async acceptCallIn () {
      await this.getMedia()
      this.socket.emit('subscribe', {
        room: this.receivingCall.room,
        socketId: this.socket.io.engine.id,
      })
    },

    rejectCallIn () {
      this.socket.emit('unsubscribe', {
        room: this.receivingCall.room,
        socketId: this.socket.io.engine.id,
      })
      this.receivingCall = null
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue